var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlank24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_13997)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D3DAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5998 8.075C14.5998 7.35833 14.3623 6.78333 13.8873 6.35C13.4123 5.91667 12.7831 5.7 11.9998 5.7C11.5165 5.7 11.079 5.80417 10.6873 6.0125C10.2956 6.22083 9.95815 6.525 9.67481 6.925C9.40815 7.30833 9.04565 7.52917 8.58731 7.5875C8.12898 7.64583 7.73315 7.525 7.39981 7.225C7.16648 7.00833 7.03731 6.74167 7.01231 6.425C6.98731 6.10833 7.06648 5.80833 7.24981 5.525C7.78315 4.725 8.46231 4.10417 9.28731 3.6625C10.1123 3.22083 11.0165 3 11.9998 3C13.6165 3 14.929 3.45833 15.9373 4.375C16.9456 5.29167 17.4498 6.49167 17.4498 7.975C17.4498 8.725 17.2915 9.4 16.9748 10C16.6581 10.6 16.0748 11.3083 15.2248 12.125C14.6081 12.7083 14.1915 13.1625 13.9748 13.4875C13.7581 13.8125 13.6165 14.1833 13.5498 14.6C13.4831 15 13.3123 15.3333 13.0373 15.6C12.7623 15.8667 12.4331 16 12.0498 16C11.6665 16 11.3373 15.8708 11.0623 15.6125C10.7873 15.3542 10.6498 15.0333 10.6498 14.65C10.6498 14 10.7915 13.4042 11.0748 12.8625C11.3581 12.3208 11.8331 11.75 12.4998 11.15C13.3498 10.4 13.9123 9.82083 14.1873 9.4125C14.4623 9.00417 14.5998 8.55833 14.5998 8.075ZM11.9998 22C11.4498 22 10.979 21.8042 10.5873 21.4125C10.1956 21.0208 9.99981 20.55 9.99981 20C9.99981 19.45 10.1956 18.9792 10.5873 18.5875C10.979 18.1958 11.4498 18 11.9998 18C12.5498 18 13.0206 18.1958 13.4123 18.5875C13.804 18.9792 13.9998 19.45 13.9998 20C13.9998 20.55 13.804 21.0208 13.4123 21.4125C13.0206 21.8042 12.5498 22 11.9998 22Z",
    fill: "#8595A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_13997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank24);
export default __webpack_public_path__ + "static/media/blank-24.a3669efdf0fac2f22ce2c3404608b6a1.svg";
export { ForwardRef as ReactComponent };